if (!customElements.get("multipack-bundle")) {
  customElements.define(
    "multipack-bundle",
    class MultipackBundle extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.unitLabel = (this.dataset.unitLabel || "").trim();
        this.formId = this.dataset.formId;
        this.syncStickyPrice = this.dataset.syncStickyPrice !== "false";

        this.onChange = this.onChange.bind(this);
        this.addEventListener("change", this.onChange);

        this.applySelection(this.selectedOption);

        if (
          typeof subscribe === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          this.unsubscribe = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.onVariantChange.bind(this),
          );
        }
      }

      disconnectedCallback() {
        this.removeEventListener("change", this.onChange);
        if (this.unsubscribe) this.unsubscribe();
      }

      get options() {
        return Array.from(this.querySelectorAll(".wt-multipack__option"));
      }

      get selectedOption() {
        const checked = this.querySelector('input[type="radio"]:checked');
        return checked
          ? checked.closest(".wt-multipack__option")
          : this.options[0];
      }

      onChange(event) {
        const radio = event.target;
        if (!radio.matches('input[type="radio"]')) return;

        this.applySelection(radio.closest(".wt-multipack__option"));
      }

      /* Re-renders the tiers with the prices of the newly selected variant and
         keeps the previously picked tier selected.

         variantChange is published by every variant-options on the page, so the
         event has to be matched twice before anything is touched: on the section
         id, to ignore other sections such as a featured product, and on the
         product id, because the quick add drawer publishes under the product
         page's own section id (see quick-add.js) and would otherwise hand us
         another product's prices. */
      onVariantChange(event) {
        if (!event || !event.data || !event.data.html) return;
        if (event.data.sectionId !== this.sectionId) return;

        const source = event.data.html.getElementById(
          `Multipack-${event.data.sectionId}-${this.dataset.blockId}`,
        );
        if (!source || source.dataset.productId !== this.productId) return;

        const destination = this.querySelector(".wt-multipack__options");
        const sourceOptions = source.querySelector(".wt-multipack__options");
        if (!sourceOptions || !destination) return;

        const selectedIndex = this.options.indexOf(this.selectedOption);
        destination.innerHTML = sourceOptions.innerHTML;

        const options = this.options;
        const restored = options[selectedIndex] || options[0];
        if (restored) {
          const radio = restored.querySelector('input[type="radio"]');
          if (radio) radio.checked = true;
        }

        this.applySelection(this.selectedOption);
      }

      applySelection(option) {
        if (!option) return;

        this.options.forEach((item) => {
          item.classList.toggle(
            "wt-multipack__option--active",
            item === option,
          );
        });

        const radio = option.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;

        const qty = parseInt(option.dataset.multipackQty, 10) || 1;
        this.updateQuantity(qty);

        if (this.syncStickyPrice) this.updateStickyPriceBlock(option);
      }

      updateQuantity(qty) {
        const form =
          (this.formId && document.getElementById(this.formId)) ||
          this.closest("form") ||
          document.querySelector('[data-type="add-to-cart-form"]');

        if (!form) return;

        const existingInput = form.querySelector('input[name="quantity"]');
        if (existingInput) {
          if (existingInput.value !== String(qty)) {
            existingInput.value = qty;
            // The value is set right away, so add to cart is always right; only
            // the notification waits for the paint. Google Analytics' form
            // tracking answers the first change in a form with ~50 ms of work,
            // which landed inside the pack tap (INP).
            requestAnimationFrame(() => {
              setTimeout(() => {
                existingInput.dispatchEvent(new Event("change", { bubbles: true }));
              });
            });
          }
          return;
        }

        let hiddenInput = form.querySelector(
          'input[data-multipack-quantity="true"]',
        );
        if (!hiddenInput) {
          hiddenInput = document.createElement("input");
          hiddenInput.type = "hidden";
          hiddenInput.name = "quantity";
          hiddenInput.dataset.multipackQuantity = "true";
          form.appendChild(hiddenInput);
        }
        hiddenInput.value = qty;
      }

      updateStickyPriceBlock(option) {
        if (!this.sectionId) return;

        this.updateStickyTitle(option);

        const stickyPriceBlock = document.getElementById(
          `sticky-price-${this.sectionId}`,
        );
        if (!stickyPriceBlock) return;

        stickyPriceBlock.classList.add("wt-multipack-sticky");
        stickyPriceBlock
          .querySelectorAll(".wt-multipack__price--sticky")
          .forEach((el) => el.remove());

        const unitPrice = option.dataset.stickyUnit;
        if (!unitPrice) return;

        const note = document.createElement("span");
        note.className =
          "wt-multipack__price wt-multipack__price--unit wt-multipack__price--sticky";
        // Same rule as the tier card: a suffix starting with a slash hugs the price
        const separator = this.unitLabel.startsWith("/") ? "" : " ";
        note.textContent = this.unitLabel
          ? `${unitPrice}${separator}${this.unitLabel}`
          : unitPrice;
        stickyPriceBlock.appendChild(note);
      }

      updateStickyTitle(option) {
        const title = document.getElementById(`sticky-title-${this.sectionId}`);
        if (!title) return;

        const pack = option.dataset.stickyPack;
        let packEl = title.querySelector(".wt-multipack__sticky-pack");
        if (!pack) {
          if (packEl) packEl.remove();
          return;
        }

        if (!packEl) {
          packEl = document.createElement("span");
          packEl.className = "wt-multipack__sticky-pack";
          title.appendChild(packEl);
        }
        packEl.textContent = ` (${pack})`;
      }
    },
  );
}
